import { cn } from '~/shared/lib/utils'
import { Card } from '~/shared/ui/card'
import { SparkBars } from '~/shared/ui/stacked-bars/spark-bars'
import { formatChange } from '../lib/overview-format'

interface KpiTileProps {
  label: string
  value: string
  locale: string
  change?: number | null
  changeLabel?: string
  sparkline?: readonly number[]
  className?: string
}

export function KpiTile({
  label,
  value,
  locale,
  change,
  changeLabel,
  sparkline,
  className,
}: KpiTileProps) {
  return (
    <Card className={cn('flex min-w-0 flex-col gap-3 p-5', className)}>
      <p className="font-medium text-muted-foreground text-xs uppercase tracking-wider">{label}</p>
      <div className="flex items-end justify-between gap-3">
        <p className="font-semibold font-serif text-3xl text-foreground tabular-nums leading-none tracking-tight">
          {value}
        </p>
        {sparkline && sparkline.length > 1 && (
          <SparkBars values={sparkline} className="text-[var(--metric-views)]" />
        )}
      </div>
      {typeof change === 'number' && (
        <p className="flex flex-wrap items-baseline gap-x-1.5 text-xs">
          <span
            className={cn(
              'font-medium tabular-nums',
              change > 0 ? 'text-[var(--metric-up)]' : 'text-muted-foreground',
            )}
          >
            {formatChange(change, locale)}
          </span>
          {changeLabel && <span className="text-muted-foreground">{changeLabel}</span>}
        </p>
      )}
    </Card>
  )
}
